export default "__VITE_ASSET__CqU0BtgK__"